module.exports = __webpack_public_path__ + "static/media/whiteHeartIcon.09cd27b2.svg";